export default {
  customer: {
    saved: 'Dina uppgifter har sparats.'
  },
  authentication: {
    cancelled: 'Identifieringen avbröts.',
    loggedOut: 'Du har loggats ut'
  }
}
